import React from 'react';
import { motion } from 'framer-motion';
import girlWithLaptop from '../../../assets/images/appointment_screen/girl_with_laptop.jpg';

const ExpectFromTelehealth = () => {
  const checklistItems = [
    'Ensure that you have a device that can connect to the internet and provide audio and visual feedback',
    'Download “Zoom” software for use during the therapy sessions',
    'Complete a test run to ensure that your device is able to open Zoom and join a meeting',
    'Prepare a quiet space for you and your child to use during the telehealth therapy session',
    'For follow-up sessions, be sure to discuss any toys and/or equipment that may be beneficial for your child to access during sessions.',
  ];

  return (
    <main className="relative max-w-[1200px] mx-auto h-full px-4 md:px-10 py-8 md:py-24 xl:py-28 3xl:pt-36 z-10">
      <h4 className="text-[34px] sm:text-[45px] md:text-[50px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] max-w-[700px]">
        What to expect for Telehealth Evaluations and therapy sessions?
      </h4>
      <p className="text-[24px] sm:text-[28px] md:text-[32px] text-[#7B54A2] font-bold leading-tight max-w-[95%] mt-6">
        If you are joining a therapy evaluation or treatment session via
        telehealth, please ensure that you have proper equipment set up prior to
        your child’s appointment. The therapist will send you an email with a
        link to join a secure, HIPAA-compliant, zoom meeting for the therapy
        session
      </p>

      <div className="flex flex-col md:flex-row gap-10 md:gap-20 mt-10 sm:mt-20">
        <div
          className="flex-1 rounded-3xl p-4 sm:p-8"
          style={{
            background:
              'linear-gradient(-45deg, #493F99 0%, #755EA8 67%, #D36CAA 100%)',
          }}
        >
          <p className="text-[24px] sm:text-[28px] md:text-[32px] text-white font-bold leading-tight max-w-[95%]">
            Telehealth Sessions Checklist
          </p>
          <ul className="list-decimal ml-6 sm:ml-6">
            {checklistItems.map((item, index) => (
              <li
                className="text-[20px] sm:text-[25px] text-white font-bold leading-tight max-w-[95%] mt-4 sm:mt-6"
                key={index}
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex-1 flex flex-col gap-6 sm:gap-10">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <img
              src={girlWithLaptop}
              alt="Child receiving therapy via telehealth session"
              className="rounded-3xl max-h-[400px]"
            />
          </motion.div>
          <p className="text-[24px] sm:text-[28px] md:text-[32px] text-secondary font-bold leading-tight max-w-[95%]">
            If you have any issues with joining the Zoom telehealth session,
            please call our front desk at{' '}
            <a href="tel:phone " className="text-pink">
              (907) 376-4880
            </a>
            , so that we can assist you in this process.
          </p>
        </div>
      </div>
    </main>
  );
};

export default ExpectFromTelehealth;
